import { render, staticRenderFns } from "./field-table.html?vue&type=template&id=4fa1bc6d&scoped=true&external"
import script from "./field-table.js?vue&type=script&lang=js&external"
export * from "./field-table.js?vue&type=script&lang=js&external"
import style0 from "./field-table.scss?vue&type=style&index=0&id=4fa1bc6d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1bc6d",
  null
  
)

export default component.exports